module.exports = __webpack_public_path__ + "static/media/image7.bc71f10b.jpg";